import React, { useState } from "react";
import PageTitle from "../components/PageTitle";
import Collaboration from "../components/Collaboration";
import BlogList from "../components/BlogList";
import Blog from "../components/Blog";
// import HeaderLabel from "../components/HeaderLabel";
import { FaSearch } from "react-icons/fa";
import { Outlet, redirect } from "react-router-dom";
import { useNavigation } from "react-router-dom";

const categories = [
  {
    id: 1,
    text: "Hobies",
    score: 14,
  },
  {
    id: 2,
    text: "Men",
    score: 150,
  },
  {
    id: 3,
    text: "Women",
    score: 206,
  },
];
const tags = ["General", "irure", "consectetur", "adipisicing", "sunt"];

export function action() {
  return redirect("list");
}

export default function BlogPage() {
  const [selectedCategory, setSelectedCategory] = useState(1);

  return (
    <>
      <PageTitle title={"Blog Page"} path={["Pages", "Blog Page"]} />
      <div className="flex justify-between max-w-5xl mx-auto font-fontOne mt-10">
        {/* col 1 */}
        <div className="w-8/12">
          <Outlet />
        </div>
        {/* col 2 */}
        <div className="w-4/12 p-4 font-fontTwo">
          <HeaderLabel>Search</HeaderLabel>
          <div className="flex px-2 border h-10 rounded-sm">
            <input
              type={"text"}
              placeholder="search for posts"
              className="flex-1 focus:outline-none"
            />
            <button type="submit">
              <FaSearch className=" text-sub_text_color" />
            </button>
          </div>
          <HeaderLabel className="mt-6">Categories</HeaderLabel>
          <div className="grid grid-cols-2 gap-2">
            {categories.map((value, index) => (
              <button
                onClick={() => {
                  setSelectedCategory(value.id);
                }}
                className={`${
                  selectedCategory === value.id && "text-white bg-pink "
                } py-2 w-full mr-2 `}
              >{`value.text (${value.score})`}</button>
            ))}
          </div>
          <HeaderLabel className="mt-6">Tags</HeaderLabel>
          <div className=" grid grid-cols-3  gap-2">
            {tags.map((value, index) => (
              <div className="underline" key={index}>
                {value}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Collaboration />
    </>
  );
}

function HeaderLabel({ children, className }) {
  return (
    <div className={`${className} font-bold text-lg font-fontOne`}>
      {children}
    </div>
  );
}
